import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_bundlesharedcatalog-module"
    }}>{`Magento_BundleSharedCatalog module`}</h1>
    <p>{`The Magento_BundleSharedCatalog module enables bundle products to be added to a shared catalog in an B2B environment. This module extends Magento_SharedCatalog module and Magento_Bundle module.`}</p>
    <p>{`The Magento_BundleSharedCatalog module provides the following features:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Display and manage prices for bundle products within a shared catalog.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Control the visibility of bundle products in quotes and orders. Only those bundle products that have been added to a shared catalog will be available for searches via the "Add by SKU" feature in quotes and orders.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`This module has a dependency on the Magento_SharedCatalog and Magento_Bundle, which must be installed and enabled first.`}</p>
    <p>{`The Magento_BundleSharedCatalog module does not create any backward incompatible changes and can be uninstalled at any time.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/build/component-file-structure/"
      }}>{`Learn about a typical file structure for a Magento 2 module`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_BundleSharedCatalog module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_BundleSharedCatalog module.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`You can extend and override layouts in the `}<inlineCode parentName="p">{`Magento\\BundleSharedCatalog\\view\\adminhtml\\layout`}</inlineCode>{` directories.`}</p>
    <p>{`For more information about layouts, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h3 {...{
      "id": "ui-components"
    }}>{`UI components`}</h3>
    <p>{`The following directory contains extensible UI components:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento\\BundleSharedCatalog\\view\\adminhtml\\ui_component`}</inlineCode>{` - renderer for pricing and structure listings`}</li>
    </ul>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/ui-components/components/listing-grid/"
      }}>{`UI Listing/Grid Component`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.0.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      